var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "221.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 221.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644 1989 c-192 -33 -389 -159 -502 -322 -265 -384 -141 -906 268 -1130 115 -63 333 -111 419 -92 l31 7 0 114 0 114 -78 0 c-143 0 -264 46 -365 139 -121 112 -178 238 -180 396 -1 154 52 284 158 390 101 101 226 154 378 160 l82 3 0 114 0 113 -80 2 c-44 0 -103 -3 -131 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1995 1993 c-191 -26 -397 -147 -510 -298 -109 -145 -157 -287 -158 -465 0 -126 15 -208 59 -312 94 -224 302 -399 537 -453 81 -18 199 -29 231 -21 l26 6 0 115 0 115 -78 0 c-151 0 -276 52 -384 160 -64 64 -120 157 -143 238 l-6 22 225 0 226 0 0 120 0 120 -225 0 c-124 0 -225 2 -225 5 0 2 10 30 21 62 80 215 279 355 506 357 l83 1 0 118 0 117 -77 -1 c-43 -1 -91 -4 -108 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 314 c-15 -7 -18 -64 -3 -64 6 0 10 9 10 20 0 43 95 38 106 -5 14 -56 -5 -97 -72 -162 -89 -86 -87 -93 31 -93 86 0 95 2 95 19 0 17 -8 18 -75 17 -41 0 -75 1 -75 3 0 2 30 31 66 65 62 57 67 65 71 111 4 42 2 53 -16 69 -21 19 -111 32 -138 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 285 c0 -35 16 -49 22 -19 4 21 128 27 128 6 0 -7 -27 -66 -60 -132 -33 -66 -60 -122 -60 -125 0 -3 6 -5 13 -5 12 0 147 274 147 298 0 8 -28 12 -95 12 l-95 0 0 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583 310 c-49 -20 -60 -110 -18 -150 21 -20 31 -22 75 -17 48 6 50 5 50 -19 0 -78 -84 -127 -124 -72 l-16 23 2 -30 c3 -27 6 -30 44 -33 55 -4 90 11 113 49 42 69 33 200 -16 239 -27 21 -72 25 -110 10z m87 -25 c7 -8 15 -36 18 -61 5 -51 -4 -64 -50 -64 -37 0 -58 25 -58 70 0 22 7 45 16 54 20 20 58 21 74 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 285 c0 -35 16 -49 22 -19 4 21 128 27 128 6 0 -7 -27 -66 -60 -132 -33 -66 -60 -122 -60 -125 0 -3 6 -5 13 -5 12 0 147 274 147 298 0 8 -28 12 -95 12 l-95 0 0 -35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeDark);
export default __webpack_public_path__ + "static/media/ce_dark.6935c070cc8dab7ac148b07979129f54.svg";
export { ForwardRef as ReactComponent };